import { Theme } from "@material-ui/core/styles";
import RunningIcon from "@material-ui/icons/DirectionsRun";
import { makeStyles } from "@material-ui/styles";
import { RefObject, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { closeAllRightPanels } from "../../../../../../../common/appState";
import * as vocabStore from "../../../../../../../store/VocabQuizStore";
import { ApplicationState } from "../../../../../../../store/configureStore";
import { Link } from "../../../../../../shared/Link/LinkWithYouTube";
import { InitialView } from "../../MyPageTop/types";
import "../../style.css";
import { useProgress } from "../../useProgress";
import { OpenableCard } from "./OpenableCard";

type CardsOuterProps = {
    initialView?: InitialView;
    scrollableContainerRef: RefObject<HTMLDivElement>;
};
type CardsInnerProps = CardsOuterProps &
    vocabStore.IVocabQuizState &
    vocabStore.ActionCreators;

export const ProgressCard = connect(
    (state: ApplicationState) => state.vocabQuiz,
    dispatch => bindActionCreators(vocabStore.actionCreators, dispatch)
)(function ({
    loadAllGenres,
    allGenres,
    initialView,
    scrollableContainerRef,
}: CardsInnerProps) {
    const {
        hiraganaProgress,
        katakanaProgress,
        vocabProgress,
        enToHiraganaProgress,
        enToKanjiProgress,
        kanjiProgress,
        actionGameProgress,
        grammarProgress,
        kanjiTestProgress,
        totalProgress,
    } = useProgress(loadAllGenres, allGenres);

    const tableContents: {
        name: string;
        link: string;
        progress: string;
    }[] = [
        {
            name: "Hiragana Quiz:",
            link: "/hiragana-quiz",
            progress: `${hiraganaProgress}%`,
        },
        {
            name: "Katakana Quiz:",
            link: "/katakana-quiz",
            progress: `${katakanaProgress}%`,
        },
        {
            name: "Grammar Test:",
            link: "/grammar",
            progress: `${grammarProgress}%`,
        },
        {
            name: "Vocab Quiz:",
            link: "/vocabulary-quiz",
            progress: `${vocabProgress}%`,
        },
        {
            name: "Kanji Test:",
            link: "/kanji",
            progress: `${kanjiTestProgress}%`,
        },
        {
            name: "English to Hiragana:",
            link: "/EnToHiragana-quiz",
            progress: `${enToHiraganaProgress}%`,
        },
        {
            name: "English to Kanji:",
            link: "/EnToKanji-quiz",
            progress: `${enToKanjiProgress}%`,
        },
        {
            name: "Kanji to Hiragana:",
            link: "/kanji-quiz",
            progress: `${kanjiProgress}%`,
        },
        {
            name: "Action Game:",
            link: "/ninja",
            progress: `${actionGameProgress}/3`,
        },
    ];

    const [open, setOpen] = useState(false);

    const c = useStyles();

    return (
        <OpenableCard
            title={
                <span>
                    Progress:{" "}
                    <span className={c.titlePercentage}>{totalProgress}%</span>
                </span>
            }
            icon={<RunningIcon />}
            saveKey="MyPageProgressPercentageCard"
            id="MyPageProgressPercentageCard"
            open={open}
            setOpen={setOpen}
            initiallyOpenedId={initialView}
            scrollableContainerRef={scrollableContainerRef}
            alwaysShowIcon
        >
            <div className={c.container}>
                <h2 className="progressTitle">{"Your Progress"}</h2>

                <table className="progressTable">
                    <tbody>
                        <tr className="totalTr">
                            <td className="bold x-large">{"Total:"}</td>
                            <td className="alignRight total">
                                {totalProgress}%
                            </td>
                        </tr>
                        {tableContents.map(co => (
                            <tr key={co.name}>
                                <td>{co.name}</td>
                                <td className="alignRight">
                                    <Link
                                        to={co.link}
                                        onClick={closeAllRightPanels}
                                    >
                                        {co.progress}
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </OpenableCard>
    );
});
const useStyles = makeStyles<Theme>(theme => ({
    container: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginBottom: 30,
    },
    titlePercentage: { color: theme.palette.success.dark },
}));
